import { call, put, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eCrmSurveyFormQuestionActionTypeIds } from '../../action-types/crm-survey/ICrmSurveyFormQuestionActionTypes';
import { actions } from '../../actions/actionsWrapper';



export function* crmSurveyFormQuestionSaga(): any {
    yield takeLatest(eCrmSurveyFormQuestionActionTypeIds.LOAD_START, loadWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.crmSurveyForm.crmSurveyFormQuestion.selectAll);
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.LOAD_ERROR(res.message ?? "Error"))
    }
}
